<template>
  <div>
    <br><br><br>
    <Hero/>
    <Smart v-if="false" />
    <Simple/>
    <Secure/>
    <Solutions v-if="false"/>
    <Calltoaction v-if="false"/>
    <VideoModal/>
  </div>
</template>

<script>
import Hero from "@/components/other-pages/sessions/Hero";
import Smart from "@/components/other-pages/sessions/Smart";
import Secure from "@/components/other-pages/sessions/Secure";
import Simple from "@/components/other-pages/sessions/Simple";
import Solutions from "@/components/other-pages/sessions/Solutions";
import Packages from "@/components/other-pages/sessions/Packages";
import Calltoaction from "@/components/other-pages/sessions/Calltoaction";
import VideoModal from "@/components/other-pages/guide/VideoModal";
import config from "@/assets/_config.json"

export  default {
  data(){
    return{
      config
    }
  },
  components: {
    Hero,
    Smart,
    Secure,
    Simple,
    Solutions,
    Packages,
    Calltoaction,
    VideoModal
  }
}
</script>

<style lang="scss" scoped>

</style>